// src/config/keycloak.ts
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  // url: process.env.REACT_APP_KEYCLOAK_URL as string, // or /realms if using newer Keycloak versions
  // realm: process.env.REACT_APP_KEYCLOAK_REALM_NAME as string,
  // clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string,
  // url: 'https://keycloak-guarden.ebosrndportal.com/', // or /realms if using newer Keycloak versions
  url: 'https://keycloak-guarden.ebosrndportal.com/',
  realm: 'guarden',
  clientId: 'portal_client',
});

export default keycloak;
